/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { JobStatus } from './JobStatus';
import { JobStatusFromJSON, JobStatusFromJSONTyped, JobStatusToJSON } from './JobStatus';
import type { AiModelTaskType } from './AiModelTaskType';
import { AiModelTaskTypeFromJSON, AiModelTaskTypeFromJSONTyped, AiModelTaskTypeToJSON } from './AiModelTaskType';

/**
 *
 * @export
 * @interface DataPipelineCount
 */
export interface DataPipelineCount {
  /**
   *
   * @type {AiModelTaskType}
   * @memberof DataPipelineCount
   */
  taskTypeCount: AiModelTaskType;
  /**
   *
   * @type {JobStatus}
   * @memberof DataPipelineCount
   */
  statusCount: JobStatus;
  /**
   *
   * @type {{ [key: string]: number; }}
   * @memberof DataPipelineCount
   */
  modelNameCount: { [key: string]: number };
}

/**
 * Check if a given object implements the DataPipelineCount interface.
 */
export function instanceOfDataPipelineCount(value: object): value is DataPipelineCount {
  if (!('taskTypeCount' in value) || value['taskTypeCount'] === undefined) return false;
  if (!('statusCount' in value) || value['statusCount'] === undefined) return false;
  if (!('modelNameCount' in value) || value['modelNameCount'] === undefined) return false;
  return true;
}

export function DataPipelineCountFromJSON(json: any): DataPipelineCount {
  return DataPipelineCountFromJSONTyped(json, false);
}

export function DataPipelineCountFromJSONTyped(json: any, ignoreDiscriminator: boolean): DataPipelineCount {
  if (json == null) {
    return json;
  }
  return {
    taskTypeCount: AiModelTaskTypeFromJSON(json['task_type_count']),
    statusCount: JobStatusFromJSON(json['status_count']),
    modelNameCount: json['model_name_count'],
  };
}

export function DataPipelineCountToJSON(value?: DataPipelineCount | null): any {
  if (value == null) {
    return value;
  }
  return {
    task_type_count: AiModelTaskTypeToJSON(value['taskTypeCount']),
    status_count: JobStatusToJSON(value['statusCount']),
    model_name_count: value['modelNameCount'],
  };
}
